"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AbstractService2 = _interopRequireDefault(require("../../AbstractService"));

var _ServiceException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ServiceException"));

var _UrlUtility = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/util/UrlUtility"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * This class handles fetching series gallery application data.
 */
var SeriesGalleryService = /*#__PURE__*/function (_AbstractService) {
  _inherits(SeriesGalleryService, _AbstractService);

  var _super = _createSuper(SeriesGalleryService);

  function SeriesGalleryService() {
    _classCallCheck(this, SeriesGalleryService);

    return _super.apply(this, arguments);
  }

  _createClass(SeriesGalleryService, [{
    key: "getApplications",

    /**
     * Returns application data.
     *
     * @param {String} locale Locale.
     * @return {Promise} Promise object.
     */
    value: function getApplications(locale) {
      var countryAndLanguage = locale ? locale.split('_') : [];

      if (countryAndLanguage.length <= 1) {
        throw new _ServiceException.default('Failed to compose URL. Property "locale" has not been defined in the correct format.', this);
      }

      var country = countryAndLanguage[1].toLowerCase();
      var language = countryAndLanguage[0].toLowerCase();

      var appInfo = _UrlUtility.default.getAppInfo();

      return this._getSeriesGalleryApps().then(function (seriesGalleryApps) {
        return seriesGalleryApps.map(function (app) {
          return Object.assign({}, app, {
            url: app.url.replace('{origin}', window.location.origin).replace('{id}', app.id).replace('{country}', country).replace('{language}', language).replace('{applications}', appInfo.seriesGallery.applications.join(',')).replace('{defaultApplication}', appInfo.seriesGallery.defaultApplication || '').replace('{storeId}', appInfo.storeId || '')
          });
        });
      });
    }
    /**
     * Fetch applications for series gallery.
     *
     * @return {Promise} Promise object.
     */

  }, {
    key: "_getSeriesGalleryApps",
    value: function _getSeriesGalleryApps() {
      return fetch('/addon-app/components/common-resources/resource-series-gallery/latest/', {
        credentials: 'same-origin'
      }).then(this._handleJsonResponse.bind(this)).catch(this._rejectWrapper.bind(this));
    }
    /**
     * Returns the name used by ServiceFactory.
     *
     * @override
     * @return {String} Factory name.
     */

  }], [{
    key: "factoryName",
    get: function get() {
      return 'seriesgallery';
    }
  }]);

  return SeriesGalleryService;
}(_AbstractService2.default);

exports.default = SeriesGalleryService;